import ConfirmActionModal from 'components/ui/ConfirmActionModal';
import React from 'react';

interface PropTypes {
  openState: boolean;
  onClose: () => void;
}

export const NewWayStreetReportModal = (props: PropTypes) => {
  return (
    <ConfirmActionModal
      openState={props.openState}
      onClose={props.onClose}
      header={'New Way Abstract order'}
      headerSymbol={'!'}
      height={300}
      info={
        'New Way Abstract requires Street Reports from the onset of their order. Please do not wait for reponses from Municipal Requests before completing the Street Report!'
      }
      actionFunction={props.onClose}
      buttonText={'Close'}
      hideSecondaryButton={true}
    />
  );
};
